import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button,
} from 'antd';
import Success from '@Images/admin/success.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';

/**
 *
 */
function ZohoSuccess({ history }) {
  return (
    <div className="zoho-success__wrapper">

      <div className="zoho-success-action-wrapper__align">

        <img
          src={Success}
          alt="success "
          width="70px"
          height="70px"
          style={{
            marginBottom: '12px',
            marginTop: '10px',

          }}
        />

        <p className="zoho-success-heading">Your Zoho account is now Connected!</p>
        <p className="zoho-success-subheading">Your transactions on Procuzy are now in Sync with your Zoho account.</p>

        <div style={{ marginTop: '40px' }}>

          <H3Button
            text="Back to Integrations"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => history.push('/admin/integration/')}
            customClass="zoho__back-submit"
          />

        </div>

      </div>
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({

});
ZohoSuccess.propTypes = {
  history: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ZohoSuccess));
